import { formatDateTime } from '@catering/ui';

import type { DeliveryNoteStatus } from './api';

export interface PortalStatusLabelExtra {
  receiverName?: string | null | undefined;
  signedAt?: string | null | undefined;
  voidReason?: string | null | undefined;
}

/**
 * `portal-delivery-notes/spec.md` → "Visibilidad de estado sin
 * discrepancias" (RF-09-P-03): a pure function, no business logic in
 * `PortalDeliveryNotesPage` (design.md §10).
 */
export function toPortalStatusLabel(
  status: DeliveryNoteStatus,
  extra: PortalStatusLabelExtra,
): string {
  switch (status) {
    case 'PENDING':
    case 'DISPATCHED':
      return 'En reparto';
    case 'DELIVERED':
      return 'Entregado, aguardando certificación';
    case 'SIGNED': {
      const receiver = extra.receiverName ?? '';
      const signedAt =
        extra.signedAt !== null && extra.signedAt !== undefined
          ? formatDateTime(extra.signedAt)
          : '';

      return `Certificado — ${receiver} — ${signedAt}`;
    }
    case 'INVOICED':
      return 'Facturado';
    case 'VOID':
      return `Anulado — ${extra.voidReason ?? ''}`;
  }
}
